import React, { useEffect } from 'react';
import { marketingUrl } from '../lib/marketingUrls';

interface MarketingRedirectProps {
  /** Path on the marketing site, e.g. `/about` */
  to: string;
}

/**
 * Sends the browser to the same path on the public marketing origin (bookmark / legacy URL support).
 */
const MarketingRedirect: React.FC<MarketingRedirectProps> = ({ to }) => {
  useEffect(() => {
    window.location.replace(marketingUrl(to));
  }, [to]);

  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
};

export default MarketingRedirect;
